import { createUseStyles } from 'react-jss'

const styleOverride = createUseStyles({
  root: {
    '& svg': {
      width: '24px',
      height: '24px',
    },
    '& path': {
      fill: 'white',
      fillOpacity: '1',
    },
    '& circle': {
      cx: '12px',
      cy: '12px',
      r: '12px',
      fill: '#008330',
    },
    fill: 'none',
    stroke: '#008330',
    strokeWidth: '0',
  },
})

export default styleOverride
